export const news = [
  {
    id: "1001",
    title: "《星光练习生》第三季首播舞台片段流出，网友吵翻了",
    category: "综艺现场",
    categorySlug: "variety",
    excerpt:
      "节目首播当晚，一段舞台练习室片段在社交平台被反复转发，围绕镜头分配与编舞难度，讨论迅速分成两派，话题一路冲到热搜前排。",
    content: [
      "《星光练习生》第三季在周五晚正式开播，节目组放出的第一期舞台完整版在两小时内讨论量突破百万。真正把话题推上风口的是随后流传出的一段练习室片段，镜头里几位练习生在反复抠同一个八拍，动作细节被网友逐帧放大研究。",
      "截至深夜，相关话题的阅读量仍在上涨。一部分观众认为这一季的编舞难度明显提高，舞台完成度值得肯定；另一部分观众则把注意力放在镜头分配上，认为部分选手的正面镜头偏少，希望后续节目能更均衡。",
      "节目组在当晚的官方账号下回应称，正片与花絮会陆续放出，完整舞台机位也会在后续上线。这条回应被截图转发了上万次，评论区依旧热闹。",
      "从数据看，这一季的首播热度明显高于上一季，站内搜索量在开播后一小时内翻了三倍。无论讨论走向如何，节目已经成功让全网记住了这一晚。",
    ],
    points: [
      "首播舞台完整版两小时讨论量破百万",
      "练习室片段流出后话题冲上热搜前排",
      "讨论集中在编舞难度与镜头分配两个方向",
      "节目组回应完整机位将在后续上线",
    ],
    tags: ["星光练习生", "综艺首播", "舞台片段"],
    heat: 986,
    views: "312.6万",
    time: "18 分钟前",
    author: "综艺观察组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20stage%20spotlight%20beams%20in%20amber%20and%20crimson%20haze%20minimal%20artistic%20texture%20no%20people%20editorial%20background%20high%20detail&width=1200&height=800&seq=hlwb-news-1001&orientation=landscape",
    isLive: true,
    isEvening: true,
    isFresh: true,
  },
  {
    id: "1002",
    title: "古装剧《长安雾》杀青路透曝光，服化道细节获一致好评",
    category: "影视动态",
    categorySlug: "screen",
    excerpt:
      "剧组杀青当天流出的路透照里，服装纹样与场景陈设被网友放大研究，从配色到布料质感都收获了不少好评。",
    content: [
      "历经四个月拍摄，《长安雾》在昨日下午正式杀青。最先流出的是几张片场路透，画面里演员身着深色织锦长袍，袖口纹样在光线下层次分明，被网友截图后放大了好几倍。",
      "有从事服装设计的网友在评论区逐条分析，认为这套服装在还原度与上镜效果之间找到了不错的平衡，布料垂坠感尤其出彩。也有观众把注意力放在场景陈设上，指出道具组在案几与灯烛的摆放上颇为讲究。",
      "剧组尚未公布正式物料，但从路透引发的讨论来看，观众对这部剧的美术呈现已经建立了初步期待。有剧评人表示，服化道先声夺人并不代表剧集一定好看，但至少说明制作方在细节上是用了心的。",
      "目前该剧已进入后期制作阶段，具体上线时间待定。",
    ],
    points: [
      "杀青路透中服装纹样与场景陈设被放大研究",
      "服装配色与布料质感收获较多好评",
      "剧集已进入后期制作，上线时间待定",
    ],
    tags: ["长安雾", "杀青路透", "服化道"],
    heat: 812,
    views: "268.4万",
    time: "42 分钟前",
    author: "影视观察组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20traditional%20chinese%20silk%20fabric%20texture%20in%20amber%20and%20deep%20red%20soft%20studio%20light%20minimal%20no%20people%20editorial%20background&width=1200&height=800&seq=hlwb-news-1002&orientation=landscape",
    isLive: true,
    isEvening: true,
    isFresh: true,
  },
  {
    id: "1003",
    title: "某音乐节官宣首批阵容，票务平台一度拥堵",
    category: "音乐现场",
    categorySlug: "music",
    excerpt:
      "首批阵容名单在今日中午公布，多个乐队的名字同时出现，消息发布后的一小时里票务平台访问量明显上升。",
    content: [
      "这场在秋季举办的音乐节今天中午公布了首批阵容，名单里既有近几年活跃的独立乐队，也有几组首次登上该舞台的名字。消息发布十分钟内，相关词条就挤进了热搜榜单。",
      "据网友反馈，名单公布后的一段时间里，票务平台的预订页面出现了加载缓慢的情况，有用户连续刷新了十几次才进入选座界面。平台方面随后回应称，瞬时访问量确实高于预期，已紧急扩容。",
      "阵容本身的讨论同样热烈。有人为某支乐队的首次登场感到惊喜，也有人开始规划连续两天的观演路线。评论区的关键词集中在「值回票价」和「希望不要撞场」两点上。",
      "主办方表示，完整阵容与分日安排将在近期陆续公布。",
    ],
    points: [
      "首批阵容公布十分钟内挤进热搜榜单",
      "票务平台出现加载缓慢，已紧急扩容",
      "讨论集中在观演路线与场次安排",
    ],
    tags: ["音乐节", "阵容官宣", "票务"],
    heat: 743,
    views: "221.7万",
    time: "1 小时前",
    author: "音乐现场组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20music%20festival%20stage%20lights%20amber%20and%20teal%20haze%20minimal%20artistic%20texture%20no%20people%20editorial%20background%20high%20detail&width=1200&height=800&seq=hlwb-news-1003&orientation=landscape",
    isLive: true,
    isEvening: true,
    isFresh: false,
  },
  {
    id: "1004",
    title: "国民品牌官宣全新代言阵容，海报风格引两极讨论",
    category: "品牌代言",
    categorySlug: "brand",
    excerpt:
      "品牌在今日上午发布了秋冬系列主视觉，选用了一组风格强烈的胶片质感海报，评价在社交平台上迅速分化。",
    content: [
      "这个被很多人熟悉的生活品牌在今天上午更新了秋冬系列的主视觉，一并公布了新的代言阵容。与以往干净明亮的风格不同，这一季的宣传照大量使用了胶片颗粒与暖色偏调。",
      "海报发布后，评价很快分成两派：喜欢的人认为这种松弛感让品牌显得更有质感，也更贴近秋冬氛围；另一部分人则觉得色调偏暗，第一眼不容易看清产品本身。",
      "有做视觉设计的网友指出，这组海报在社交平台的小尺寸缩略图下确实会损失一部分细节，但如果点开大图观看，构图和光影其实是经过细致设计的。",
      "品牌方暂时没有对争议作出回应，但从转发量来看，这波讨论已经为新品带来了不小的曝光。",
    ],
    points: [
      "秋冬主视觉采用胶片颗粒与暖调风格",
      "评价分化：质感派与清晰度派各有观点",
      "缩略图细节损失成为讨论焦点",
    ],
    tags: ["品牌代言", "秋冬大片", "主视觉"],
    heat: 688,
    views: "196.2万",
    time: "2 小时前",
    author: "品牌观察组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20folded%20linen%20texture%20in%20amber%20and%20cream%20soft%20studio%20light%20minimal%20no%20people%20editorial%20background%20high%20detail&width=1200&height=800&seq=hlwb-news-1004&orientation=landscape",
    isLive: false,
    isEvening: true,
    isFresh: false,
  },
  {
    id: "1005",
    title: "「夏日限定」话题冲上热搜，网友晒出同款打卡地",
    category: "网络热议",
    categorySlug: "buzz",
    excerpt:
      "一个关于夏末氛围的话题在傍晚突然升温，配图里出现了许多相似的取景角度，评论区开始互相交换地点信息。",
    content: [
      "傍晚时分，一个名为「夏日限定」的话题忽然出现在热搜中段，随后一路攀升。点进去会发现，讨论的起点其实很朴素——几位网友分享了各自拍下的夏末黄昏。",
      "有意思的是，配图里的取景角度高度相似：低角度的天空、被拉长的影子，还有远处成排的树。于是评论区迅速变成了地点交换站，有人认出其中几处是在同一座城市的公园里拍的。",
      "短短两小时，话题下已经聚集了大量同款照片，也有摄影爱好者在评论里分享了拍摄时间与光线的关系，提醒大家「黄金时刻」其实只有二十来分钟。",
      "这样的话题没有明确的新闻由头，却往往最能反映当下大家在关心什么，也让这个傍晚多了一点温柔的氛围。",
    ],
    points: [
      "话题在傍晚突然升温并攀升至热搜中段",
      "配图取景角度高度相似，评论区交换地点",
      "摄影爱好者分享黄金时刻拍摄经验",
    ],
    tags: ["夏日限定", "打卡地", "热搜话题"],
    heat: 611,
    views: "174.3万",
    time: "3 小时前",
    author: "网络热议组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20sunset%20gradient%20in%20amber%20and%20soft%20coral%20minimal%20painterly%20texture%20no%20people%20editorial%20background%20high%20detail&width=1200&height=800&seq=hlwb-news-1005&orientation=landscape",
    isLive: false,
    isEvening: false,
    isFresh: true,
  },
  {
    id: "1006",
    title: "海外剧集《霓虹街角》定档，字幕组连夜开工",
    category: "海外娱乐",
    categorySlug: "overseas",
    excerpt:
      "这部剧在海外平台上突然公布上线日期，国内观众的第一反应是——追更日历又要重排了。",
    content: [
      "备受关注的海外剧集《霓虹街角》在昨晚公布了上线时间，平台同步放出了一支时长不到一分钟的预告。消息传到国内时已经是深夜，但讨论热度丝毫未减。",
      "预告片里延续了导演一贯的冷色调都市美学，几处霓虹灯下的长镜头被网友截图收藏。有人在评论区表示，光是看预告的镜头调度就已经把期待值拉满。",
      "更实际的影响是追更安排。多个字幕组在社交账号上表示已经连夜开始准备工作，并提醒观众首集上线时间落在工作日凌晨，建议提前规划作息。",
      "该剧的具体集数与更新频率仍有待官方进一步确认。",
    ],
    points: [
      "海外平台公布上线时间并放出短预告",
      "预告延续冷色调都市美学，镜头调度获赞",
      "国内字幕组连夜开工，更新落在凌晨",
    ],
    tags: ["霓虹街角", "海外剧集", "定档"],
    heat: 560,
    views: "158.9万",
    time: "5 小时前",
    author: "海外观察组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20neon%20reflections%20on%20wet%20street%20amber%20and%20teal%20artistic%20texture%20no%20people%20editorial%20background%20high%20detail&width=1200&height=800&seq=hlwb-news-1006&orientation=landscape",
    isLive: false,
    isEvening: false,
    isFresh: false,
  },
  {
    id: "1007",
    title: "综艺《周末不打烊》新一期嘉宾名单引猜测",
    category: "综艺现场",
    categorySlug: "variety",
    excerpt:
      "节目组只放出了一张剪影海报，网友却凭借衣角和站姿把嘉宾猜了个七七八八，讨论帖越叠越高。",
    content: [
      "《周末不打烊》今天下午放出了新一期的预告海报，画面里只有三道人影剪影，配文是简单的「本周见」。就是这样一张信息量极少的图，让评论区彻底热闹了起来。",
      "网友的推理方式五花八门：有人对比往期嘉宾的站姿习惯，有人放大剪影边缘猜测服装品牌，还有人直接按节目录制档期反推可能到场的人。",
      "在这类猜谜式宣发里，节目组显然掌握着节奏。有观众调侃，现在看综艺的乐趣有一半在看大家怎么破案。",
      "完整嘉宾名单将在节目播出前公布，届时这场猜测才算了结。",
    ],
    points: [
      "节目组仅放出三道人影剪影海报",
      "网友通过站姿与服装推测嘉宾人选",
      "猜谜式宣发带动评论区讨论热度",
    ],
    tags: ["周末不打烊", "嘉宾名单", "预告海报"],
    heat: 498,
    views: "132.4万",
    time: "7 小时前",
    author: "综艺观察组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20silhouette%20shadows%20against%20amber%20gradient%20light%20minimal%20artistic%20texture%20no%20people%20editorial%20background%20high%20detail&width=1200&height=800&seq=hlwb-news-1007&orientation=landscape",
    isLive: false,
    isEvening: false,
    isFresh: false,
  },
  {
    id: "1008",
    title: "悬疑电影《雾港》首支预告发布，镜头语言获好评",
    category: "影视动态",
    categorySlug: "screen",
    excerpt:
      "预告全程几乎没有台词，靠着海浪与雾气的环境音撑起氛围，被不少观众称为「今年最有耐心的一支预告」。",
    content: [
      "《雾港》的首支预告在今天上线。与传统悬疑片快剪式的预告不同，这支两分钟的片子节奏很慢，开场是长达二十秒的港口空镜，只有海浪拍岸的声音。",
      "喜欢的人认为，这种处理方式恰恰说明导演对自己的画面有信心，也把悬念留在了观众心里；也有人担心节奏偏慢会劝退一部分路人观众。",
      "值得注意的是一位影评人的观察：预告里出现了大量水面倒影的镜头，如果这不是单纯的氛围营造，很可能与主线剧情存在呼应。这个推测让不少观众开始逐帧分析。",
      "电影目前仍未公布具体档期。",
    ],
    points: [
      "预告以慢节奏与环境音营造氛围",
      "水面倒影镜头被认为可能暗藏线索",
      "具体档期尚未公布",
    ],
    tags: ["雾港", "电影预告", "镜头语言"],
    heat: 455,
    views: "121.8万",
    time: "9 小时前",
    author: "影视观察组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20mist%20over%20water%20in%20amber%20and%20grey%20minimal%20painterly%20texture%20no%20people%20editorial%20background%20high%20detail&width=1200&height=800&seq=hlwb-news-1008&orientation=landscape",
    isLive: false,
    isEvening: false,
    isFresh: false,
  },
  {
    id: "1009",
    title: "独立乐队巡演城市名单更新，二手平台票价出现波动",
    category: "音乐现场",
    categorySlug: "music",
    excerpt:
      "巡演加场消息公布后，几个城市的票价在二手平台上出现了明显变化，也让不少人重新考虑出行安排。",
    content: [
      "这支独立乐队今天更新了巡演的城市名单，新增了两座此前呼声很高的城市。消息一出，原定场次的门票在二手平台上出现了价格波动。",
      "有粉丝在社交平台上统计了几个场次的价格区间，发现部分原价票的溢价在加场消息公布后有所回落，另一些临近城市的价格则保持坚挺。",
      "乐队在官方账号上提醒，演出门票以官方渠道为准，建议购票时留意真伪。这条提醒被大量转发。",
      "完整巡演日程与开票时间将在本周内公布。",
    ],
    points: [
      "巡演新增两座城市，呼声较高",
      "加场后部分场次二手票价有所回落",
      "乐队提醒以官方渠道购票为准",
    ],
    tags: ["独立乐队", "巡演加场", "票价"],
    heat: 412,
    views: "108.5万",
    time: "12 小时前",
    author: "音乐现场组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20audio%20waveform%20texture%20in%20amber%20and%20teal%20minimal%20artistic%20no%20people%20editorial%20background%20high%20detail&width=1200&height=800&seq=hlwb-news-1009&orientation=landscape",
    isLive: false,
    isEvening: false,
    isFresh: false,
  },
  {
    id: "1010",
    title: "老牌综艺宣布回归，主持人阵容微调引发讨论",
    category: "综艺现场",
    categorySlug: "variety",
    excerpt:
      "陪伴观众多年的节目宣布新一季回归，名单里有熟悉的面孔，也有新加入的成员，留言区里满是回忆。",
    content: [
      "这档播出多年的综艺在今天晚上官宣回归，并公布的新一季主持人阵容。老成员的保留让不少观众松了一口气，新加入的面孔则带来了新的话题。",
      "官宣微博下的留言区很快被「终于等到」刷屏，也有观众翻出早期的节目片段，对比这一路走来的变化。",
      "节目组表示，新一季在环节设计上做了调整，会保留观众熟悉的经典内容，同时加入一些与当下生活节奏更贴近的部分。",
      "具体开播时间将在后续公告中公布。",
    ],
    points: [
      "节目官宣新一季回归并公布主持阵容",
      "老成员保留、新成员加入成为话题",
      "新一季将保留经典环节并做调整",
    ],
    tags: ["老牌综艺", "主持人阵容", "回归"],
    heat: 388,
    views: "96.7万",
    time: "14 小时前",
    author: "综艺观察组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20vintage%20studio%20warm%20amber%20light%20soft%20grain%20minimal%20artistic%20texture%20no%20people%20editorial%20background%20high%20detail&width=1200&height=800&seq=hlwb-news-1010&orientation=landscape",
    isLive: false,
    isEvening: false,
    isFresh: false,
  },
  {
    id: "1011",
    title: "热播剧 OST 上线，两小时播放量破百万",
    category: "影视动态",
    categorySlug: "screen",
    excerpt:
      "剧中反复出现的那段旋律正式放出完整版本，评论区里出现最多的一句话是——终于等到了。",
    content: [
      "正在热播的剧集今天中午上线了原声带中的主打曲目。这首歌在剧中多次出现，早已被观众记住旋律，只是一直没有完整版本。",
      "上线两小时后，歌曲的播放量突破百万，评论区里出现最多的一句话是「终于等到了」。有乐评人点评，这首歌在编曲上刻意留白，副歌的处理与剧情情绪贴合得不错。",
      "剧组方面透露，完整原声带将在剧集收官前后全部放出，目前仍有几首插曲暂未公开。",
      "对于追剧的观众来说，这大概是本周最实在的一条好消息。",
    ],
    points: [
      "剧集主打曲目正式上线完整版本",
      "两小时播放量突破百万",
      "完整原声带将在收官前后放出",
    ],
    tags: ["OST", "热播剧", "原声带"],
    heat: 356,
    views: "88.3万",
    time: "16 小时前",
    author: "影视观察组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20vinyl%20record%20and%20warm%20amber%20light%20minimal%20artistic%20texture%20no%20people%20editorial%20background%20high%20detail&width=1200&height=800&seq=hlwb-news-1011&orientation=landscape",
    isLive: false,
    isEvening: false,
    isFresh: false,
  },
  {
    id: "1012",
    title: "时尚品牌秋冬大片释出，取景地被网友扒出",
    category: "品牌代言",
    categorySlug: "brand",
    excerpt:
      "广告片里的几处空旷场景很有辨识度，已经有观众在评论里贴出了疑似同一地点的旅行照，讨论热度顺势升高。",
    content: [
      "某时尚品牌在今天释出了秋冬系列的广告大片，画面里大面积的留白与低饱和色调延续了品牌一贯的审美。出乎意料的是，最先被讨论的不是服装，而是取景地。",
      "有眼尖的网友认出片中的一处盐湖与远景山脉，并把之前旅行时拍下的照片贴在评论区作对比，随后又有人补充了另外两处可能的拍摄地点。",
      "品牌方面没有公开确认具体地点，这反而让讨论持续升温。有旅游博主已经开始整理一份「同款取景地」攻略。",
      "无论最终答案如何，这组大片显然已经完成了它的任务——让人记住了画面。",
    ],
    points: [
      "广告片取景地成为讨论焦点",
      "网友贴出旅行照对比疑似同一地点",
      "取景地攻略已在整理中",
    ],
    tags: ["时尚大片", "取景地", "秋冬系列"],
    heat: 322,
    views: "79.1万",
    time: "20 小时前",
    author: "品牌观察组",
    image:
      "https://readdy.ai/api/search-image?query=warm%20abstract%20salt%20flat%20landscape%20in%20amber%20and%20cream%20minimal%20painterly%20texture%20no%20people%20editorial%20background%20high%20detail&width=1200&height=800&seq=hlwb-news-1012&orientation=landscape",
    isLive: false,
    isEvening: false,
    isFresh: false,
  },
];